import React from 'react';
import { useField } from 'formik';

export default function InputField(props) {
  const { label, ...other } = props;
  const [field, meta, helpers] = useField(props);
  const isInvalid = meta.touched && meta.error;
  
  const labelClassName = props.labelClassName
  const inputClassName = props.inputClassName

  return (
    <div
      className={`flex flex-col border-b pb-1 ${
        !isInvalid ? 'border-grey focus-within:border-blue' : 'border-[#ff0000]'
      }`}
    >

      <div className={`flex-auto text-13px font-extrabold tracking-none uppercase font-heading mb-1 ${labelClassName}`}>{label}</div>
      <input className={`w-full outline-none text-15px h-8 block ${inputClassName}`} {...field} {...other} />
    </div>
  );
}
